//
// Copyright 2025 DXOS.org
//

import React, { type PropsWithChildren } from 'react';

import { type ThemedClassName } from '@dxos/react-ui';
import { mx } from '@dxos/ui-theme';

const trail = [
  'absolute z-0 aspect-[2/1] w-16',
  'bg-[radial-gradient(at_100%_50%,_theme(colors.sky.500),_transparent_70%)]',
  '[offset-anchor:100%_50%] [offset-path:border-box]',
];

export type AnimatedBorderProps = ThemedClassName<PropsWithChildren<{ animate?: boolean }>>;

/**
 * AnimatedBorder using CSS Motion Path.
 * Based on https://cobian.dev/blog/animated-border
 */
export const AnimatedBorder = ({ children, classNames, animate = false }: AnimatedBorderProps) => {
  return (
    <div className='relative overflow-hidden p-px rounded-sm'>
      <div className={mx('relative z-10 bg-base-surface rounded-sm border border-subdued-separator', classNames)}>
        {children}
      </div>
      {animate && (
        <>
          <div className={mx(...trail, 'animate-trail')} />
          <div className={mx(...trail, 'animate-trail-offset')} />
        </>
      )}
    </div>
  );
};
